export default __webpack_public_path__ + "static/media/64.ebfb5608.gif";